//helpers
const _update_rgb_or_temp = (
	actions,
	mode = 'color',
	value: { r: number; g: number; b: number } | number = { r: 223, g: 44, b: 44 },
) => {
	/**! There is no need of mapping array => looks better, but creates new array, which is no needed*/
	for (let el of actions) {
		if (mode === 'color' && typeof value !== 'number') {
			if (el.name === 'r') el.value = (value as any)?.r || 0;
			if (el.name === 'g') el.value = (value as any)?.g || 0;
			if (el.name === 'b') el.value = (value as any)?.b || 0;
		} else if (mode === 'white' && typeof value === 'number') {
			if (el.name === 'temp' || el.name === 'ct') el.value = value;
		}
	}
	return actions;
};

const _rgb_actions_from_obj = (value = { r: 223, g: 44, b: 44 }) => {
	return [
		{ name: 'r', value: value?.r || 0 },
		{ name: 'g', value: value?.g || 0 },
		{ name: 'b', value: value?.b || 0 },
	];
};

/**
 * return actions array  [{name, value}], length >=1
 * @param id
 * @param value
 * @param mode
 */
export const fill_empty_actions = (id, value, mode = undefined) => {
	switch (id) {
		case 'color':
			return _rgb_actions_from_obj(value);
		case 'set light': //for color mode supported bulbs
			if (mode === 'color') {
				return [{ name: 'mode', value: mode }, ..._rgb_actions_from_obj(value)];
			}
			return [
				{ name: 'mode', value: 'white' },
				{ name: 'temp', value: value },
			];
		case 'temp':
			return [{ name: 'ct', value }];
		case 'turn':
		case 'state':
		case 'brightnes':
		default:
			return [{ name: id, value }];
	}
};
/**
 * when user change one mode with another,
 * updates mode action and clear/set rgb/temp if needed
 * @param actions
 * @param ind
 * @param mode
 * @param value
 */
const update_actions_by_mode = (actions, ind, mode, value) => {
	/**1s. first check if actions[ind] === mode
            1.1 if equal, check mode === color and update all actions => r,g,b
            1.2 if not
                1.2.1 check what is old mode
                1.2.2 update actions[ind] with new mode value
				1.2.3 remove old mode actions if old is color remove rgb actions, if old mode is white remove temp action 
                1.2.4 set new mode actions
        */

	if (actions[ind].value === mode) {
		return _update_rgb_or_temp(actions, mode, value);
	} else {
		if (actions[ind].value === 'color') {
			actions[ind].value = mode; //here mode must be white
			actions = [...actions.filter((el) => !['r', 'g', 'b'].includes(el.name))];
			actions.push({ name: 'temp', value });
		} else {
			actions[ind].value = mode;
			actions = [...actions.filter((el) => el.name !== 'temp' && el.name !== 'ct')];
			actions.push(..._rgb_actions_from_obj(value));
		}

		return actions;
	}
};

/**
 * Initialize the `mode` action and its payload when no mode action exists yet.
 *
 * Also strips any pre-existing color (`r`/`g`/`b`) or temperature (`temp`/`ct`)
 * entries — these can be present on legacy scenes that were saved before the
 * unified `set light` UI (FE-1730), where Color and CCT were two independent
 * toggles. Without the cleanup, switching modes would leave both payloads in
 * the action and trigger the firmware mode-switching bug.
 *
 * @param actions
 * @param mode
 * @param value
 */
const push_actions_by_mode = (actions, mode, value) => {
	actions = actions.filter((el) => !['r', 'g', 'b', 'temp', 'ct'].includes(el.name));
	actions.push({ name: 'mode', value: mode });
	if (mode === 'color') {
		actions.push(..._rgb_actions_from_obj(value));
	} else {
		actions.push({ name: 'temp', value });
	}
	return actions;
};

/** function execute only over  ID === 'color' (for now -> rgbw color mode only)
 * @param actions = [{name, value}] , length > 0 && length < n
 * @param value = [255, 22, 33]
 */
const set_color = (actions, value) => {
	//1. if actions.length === 0 , push
	//2. else -> for loop update by mode = color | white
	if (!actions.find((el) => el.name === 'r')) {
		actions.push(..._rgb_actions_from_obj(value));
	} else {
		actions = _update_rgb_or_temp(actions, 'color', value);
	}

	return actions;
};

/**
 * if action with name === id exists => update values
 * otherwise set up it
 * @param actions
 * @param id
 * @param value
 * @param mode
 */
export const update_actions = (actions, id, value, mode = undefined) => {
	let indexOfEl = -1;
	switch (id) {
		case 'set light':
			//because id = "set light" matches name === 'mode', but does not exist as a nae of action
			indexOfEl = actions.findIndex((el) => el.name === 'mode');
			if (indexOfEl !== -1) {
				return update_actions_by_mode(actions, indexOfEl, mode, value);
			} else {
				return push_actions_by_mode(actions, mode, value);
			}
		case 'color':
			let arr = [...set_color(actions, value)];
			return arr;

		case 'temp':
			indexOfEl = actions.findIndex((el) => el.name === 'ct' || el.name === 'temp');
			if (indexOfEl !== -1) {
				actions[indexOfEl].value = value;
			} else {
				actions.push({ name: 'ct', value });
			}
			return actions;

		case 'state':
		case 'turn':
		case 'brightness':
		default:
			//state, turn,. brightness
			indexOfEl = actions.findIndex((el) => el.name === id);

			if (indexOfEl !== -1) {
				actions[indexOfEl].value = value;
			} else {
				actions.push({ name: id, value });
			}
			return actions;
	}
};
